import React from 'react';
const CLIENTS = ['Taartu', 'Flow Key', 'Nova Cloud', 'TendePay', 'Skybistro', 'PixelPaints'];
export function TrustedBy() {
  const row = [...CLIENTS, ...CLIENTS];
  return <section aria-label="Clients" className="w-full overflow-hidden bg-white py-8" data-id="element-237" data-mp="msf1sf7l10iw">
      <p className="text-center text-base font-semibold text-[#2D2D2D]" data-id="element-238" data-mp="i15fnol8sfbr">
        Trusted by 50+ companies across East Africa &amp; beyond
      </p>
      <div className="relative mt-6 w-full overflow-hidden" data-id="element-239" data-mp="woqe35769qdc">
        <ul className="animate-marquee flex w-max items-center gap-20 pr-20" data-id="element-240" data-mp="rr8dq3780jgy">
          {row.map((client, index) => <li key={`${client}-${index}`} className="whitespace-nowrap text-xl font-bold tracking-tight text-[#191D49]/50" data-id="element-241" data-mp="15pomdzon8k1q" data-mpi={index}>
              {client}
            </li>)}
        </ul>
      </div>
    </section>;
}